<template>
  <div class="addCompany">
    <div class="title">
      公司资质管理 <span>{{titlename}}公司资质信息</span>
    </div>
    <div class="company_container">
      <div class="company_title">{{titlename}}公司资质信息</div>
      <div class="companymain">
        <div class="company_list">
          <label for="">
            <span>*</span>公司类型
          </label>
          <el-select v-model="company.companyType"
                     size="small">
            <el-option v-for="item in companyList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="company_list">
          <label for="">
            <span>*</span>公司名称
          </label>
          <el-input size="small"
                    v-model="company.companyName"
                    placeholder="输入公司名称"></el-input>
        </div>
        <div class="company_list">
          <label for="">
            <span>*</span>联系人
          </label>
          <el-input size="small"
                    v-model="company.linkman"
                    placeholder="输入联系人"></el-input>
        </div>
        <div class="company_list addressStyle">
          <label for="factoryname ">
            <span>*</span>公司地址
          </label>
          <el-cascader :focus="changeAddr"
                       size="small"
                       @active-item-change="handleItemChange"
                       :options="options"
                       v-model="addressFrom"
                       @change="handleChangeFrom"
                       placeholder="省市区">
          </el-cascader>
          <el-input size="small"
                    class="areaaddress"
                    v-if="changeAddr"
                    v-model="address"
                    readonly
                    @focus="handleAddrChangeClick"></el-input>
        </div>
        <div class="company_list address">
          <el-input size="small"
                    v-model="areaAddress"
                    placeholder="详细地址"></el-input>
        </div>
        <div class="company_list">
          <label for="">
            <span>*</span>联系电话
          </label>
          <el-input size="small"
                    v-model="company.phone"
                    placeholder="输入公司名称"></el-input>
        </div>
        <div class="company_list">
          <label for="">
            <span>*</span>传真
          </label>
          <el-input size="small"
                    v-model="company.fax"
                    placeholder="输入公司名称"></el-input>
        </div>
        <div class="licese">
          <div class="licese_list">
            <label for="updateImg"><span>*</span>营业执照</label>
            <div class="imgItem">
              <div class="imgUrl">
                <img v-if="licenseList.business"
                     :src="licenseList.business">
              </div>
              <div class="imgstyle">
                <div v-if="licenseList.business"
                     class="reupdate">重新上传</div>
                <div v-else
                     class="wating">点击上传图片</div>
              </div>
              <input type="file"
                     name="img"
                     id=""
                     @change="handleBusinessImgUpdate"
                     class="updateBtn"
                     accept="image/png,image/jpeg">
            </div>
          </div>
          <div class="licese_list">
            <label for="updateImg"><span>*</span>危险品经营许可证</label>
            <div class="imgItem">
              <div class="imgUrl">
                <img v-if="licenseList.dangerous"
                     :src="licenseList.dangerous">
              </div>
              <div class="imgstyle">
                <div v-if="licenseList.dangerous"
                     class="reupdate">重新上传</div>
                <div v-else
                     class="wating">点击上传图片</div>
              </div>
              <input type="file"
                     name="img"
                     id=""
                     @change="handleDangerousImgUpdate"
                     class="updateBtn"
                     accept="image/png,image/jpeg">
            </div>
          </div>
          <div class="licese_list">
            <label for="updateImg"><span>*</span>开户许可证</label>
            <div class="imgItem">
              <div class="imgUrl">
                <img v-if="licenseList.account"
                     :src="licenseList.account">
              </div>
              <div class="imgstyle">
                <div v-if="licenseList.account"
                     class="reupdate">重新上传</div>
                <div v-else
                     class="wating">点击上传图片</div>
              </div>
              <input type="file"
                     name="img"
                     id=""
                     @change="handleAccountImgUpdate"
                     class="updateBtn"
                     accept="image/png,image/jpeg">
            </div>
          </div>
          <div class="licese_list">
            <label for="updateImg"><span>*</span>开票许可证</label>
            <div class="imgItem">
              <div class="imgUrl">
                <img v-if="licenseList.billing"
                     :src="licenseList.billing ">
              </div>
              <div class="imgstyle">
                <div v-if="licenseList.billing"
                     class="reupdate">重新上传</div>
                <div v-else
                     class="wating">点击上传图片</div>
              </div>
              <input type="file"
                     name="img"
                     id=""
                     @change="handleBillingImgUpdate"
                     class="updateBtn"
                     accept="image/png,image/jpeg">
            </div>
          </div>
        </div>
        <div class="company_button">
          <el-button @click="handleAddClick">保存</el-button>
          <el-button @click="handleCancelClick">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  provinceList,
  cityList,
  areaList,
  addCompany,
  getCompanyDetail,
  updateCompanyDetail
} from 'apis/index'
import axios from 'axios'
export default {
  data () {
    return {
      companyList: [
        {
          value: '0',
          label: '货主公司'
        }, {
          value: '1',
          label: '物流公司'
        }
      ],
      company: {
        companyType: '', // 公司类型
        companyName: '', // 公司名
        phone: '', // 联系电话
        fax: '', // 传真
        linkman: '' // 联系人
      },
      options: [],
      addressFrom: [],
      from: '',
      address: '',
      id: '',
      addressCode: '',
      changeAddr: false,
      mhover: false,
      areaAddress: '',
      titlename: '添加',
      licenseList: {
        business: '', // 营业执照
        dangerous: '', // 危险品经营许可证
        account: '', // 开户许可证
        billing: '' // 开票许可证
      }
    }
  },
  methods: {
    async initData () { // 省市区三级联动
      let ret = await provinceList()
      if (ret.data.code === 0) {
        let newData = JSON.stringify(ret.data.data.result)
        newData = newData.replace(/provinceCode/g, 'value')
        newData = newData.replace(/provinceName/g, 'label')
        this.options = JSON.parse(newData)
        this.options.forEach((item, index) => {
          this.$set(this.options[index], 'children', [])
        })
      }
    },
    async handleItemChange (val) {
      if (val.length === 1) { // 请求省，且只第一次才发请求
        let provinceCode = val[0]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && !this.options[j].children.length) {
            let ret = await cityList({ provinceCode })
            if (ret.data.code === 0) {
              let newData = JSON.stringify(ret.data.data.result)
              newData = newData.replace(/cityCode/g, 'value')
              newData = newData.replace(/cityName/g, 'label')
              let newCity = JSON.parse(newData)
              newCity.forEach(item => {
                item.children = []
              })
              this.$set(this.options[j], 'children', newCity)
              break
            }
          }
        }
      }
      if (val.length === 2) { // 请求市区，且只第一次才发请求
        let provinceCode = val[0]
        let cityCode = val[1]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && this.options[j].children.length) {
            for (let k = 0; k < this.options[j].children.length; k++) {
              if (this.options[j].children[k].value === cityCode && !this.options[j].children[k].children.length) {
                let ret = await areaList({ cityCode })
                if (ret.data.code === 0) {
                  if (!ret.data.data.result.length) { // 修复中山市/东莞市等三级为空数组的情况
                    let newArea = [{
                      value: this.options[j].children[k].value,
                      label: this.options[j].children[k].label
                    }]
                    this.$set(this.options[j].children[k], 'children', newArea)
                    break
                  }
                  let newData = JSON.stringify(ret.data.data.result)
                  newData = newData.replace(/areaCode/g, 'value')
                  newData = newData.replace(/areaName/g, 'label')
                  let newArea = JSON.parse(newData)
                  this.$set(this.options[j].children[k], 'children', newArea)
                  break
                }
              }
            }
          }
        }
      }
    },
    getAddressText (value) { // 获取地址
      value.forEach(element => {
        this.addressCode += element + ','
      })
      this.addressCode = this.addressCode.slice(0, -1)
      // console.log(this.addressCode)
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value[0]) {
          this.address = this.options[i].label
          let city = this.options[i].children
          for (var j = 0; j < city.length; j++) {
            if (city[j].value === value[1]) {
              this.address += ',' + city[j].label
              let area = city[j].children
              for (var k = 0; k < area.length; k++) {
                if (area[k].value === value[2]) {
                  this.address += ',' + area[k].label
                }
              }
            }
          }
        }
      }
      //   console.log(this.options)
    },
    handleChangeFrom (value) {
      this.getAddressText(value)
      this.from = this.address
    },
    handleAddrChangeClick () {
      this.changeAddr = false
      this.addressCode = ''
    },
    getData (item) {
      getCompanyDetail({
        companyId: item
      }).then(res => {
        // console.log(res)
        // console.log('aaa', res)
        //  companyType: '', // 公司类型
        // companyName: '', // 公司名
        // phone: '', // 联系电话
        // fax: '' // 传真
        if (res.data.code === 0) {
          let data = res.data.data.company
          this.company.companyType = data.companyType
          this.company.companyName = data.companyName
          this.company.phone = data.phone
          this.company.linkman = data.linkman
          this.company.fax = data.fax
          this.address = data.region
          this.areaAddress = data.address
          this.licenseList.business = data.businessLicense.imgUrl
          this.licenseList.dangerous = data.dangerGoodsLicense.imgUrl
          this.licenseList.account = data.bankAccountLicense.imgUrl
          this.licenseList.billing = data.ticketPost.imgUrl
          this.addressCode = data.regionCode
          // console.log(this.addressCode)
        }
      })
    },
    handleBusinessImgUpdate (e) { // 营业执照上传
      const MultipartFile = e.target.files[0]
      let param = new FormData()
      param.append('MultipartFile', MultipartFile)
      axios.post('/api/admin/upload.do', param).then(response => {
        this.licenseList.business = response.data.url
      })
    },
    handleDangerousImgUpdate (e) { // 危险品经营许可证上传
      const MultipartFile = e.target.files[0]
      let param = new FormData()
      param.append('MultipartFile', MultipartFile)
      axios.post('/api/admin/upload.do', param).then(response => {
        this.licenseList.dangerous = response.data.url
      })
    },
    handleAccountImgUpdate (e) { // 开户许可证
      const MultipartFile = e.target.files[0]
      let param = new FormData()
      param.append('MultipartFile', MultipartFile)
      axios.post('/api/admin/upload.do', param).then(response => {
        this.licenseList.account = response.data.url
      })
    },
    handleBillingImgUpdate (e) { // 开票许可证
      const MultipartFile = e.target.files[0]
      let param = new FormData()
      param.append('MultipartFile', MultipartFile)
      axios.post('/api/admin/upload.do', param).then(response => {
        this.licenseList.billing = response.data.url
      })
    },
    handleImgUpdate (e, file) { // 上传图片方法
      const MultipartFile = e.target.files[0]
      let param = new FormData()
      param.append('MultipartFile', MultipartFile)
      axios.post('/api/admin/upload.do', param).then(response => {
        // console.log('e', response, 'file', file)
        // this.bannerInfo.imgUrl = response.data.url
        // this.bannerInfo.size = response.data.size
        // this.bannerInfo.suffix = response.data.subString
      })
    },
    handleAddClick () { // 保存
      // console.log(this.company)
      // console.log('省市区', this.address)
      // console.log('xiangxi', this.areaAddress)
      let companyName = this.company.companyName
      let regionCode = this.addressCode
      let region = this.address
      let address = this.areaAddress
      let phone = this.company.phone
      let fax = this.company.fax
      let linkman = this.company.linkman
      let companyType = this.company.companyType
      let businessLicense = this.licenseList.business
      let dangerGoodsLicense = this.licenseList.dangerous
      let bankAccountLicense = this.licenseList.account
      let ticketPost = this.licenseList.billing
      if (!companyName | !regionCode | !region | !address | !linkman | !phone | !fax | !companyType | !businessLicense | !dangerGoodsLicense | !bankAccountLicense | !ticketPost) {
        this.$message.error('*内容为必填项')
      } else {
        if (this.id) {
          // console.log('修改', regionCode)

          updateCompanyDetail({
            companyId: this.id,
            companyName: this.company.companyName,
            region: this.address,
            regionCode: this.addressCode,
            address: this.areaAddress,
            linkman: this.company.linkman,
            phone: this.company.phone,
            fax: this.company.fax,
            companyType: this.company.companyType,
            'businessLicense.imgUrl': this.licenseList.business,
            'dangerGoodsLicense.imgUrl': this.licenseList.dangerous,
            'bankAccountLicense.imgUrl': this.licenseList.account,
            'ticketPost.imgUrl': this.licenseList.billing
          }).then(res => {
            // console.log(res)
            if (res.data.code === 0) {
              this.$router.push({ path: '/manage/companylist' })
            }
          })
        } else {
          // console.log('添加')
          addCompany({ // 添加
            companyName: this.company.companyName,
            region: this.address,
            address: this.areaAddress,
            regionCode: this.addressCode,
            linkman: this.company.linkman,
            phone: this.company.phone,
            fax: this.company.fax,
            companyType: this.company.companyType,
            'businessLicense.imgUrl': this.licenseList.business,
            'dangerGoodsLicense.imgUrl': this.licenseList.dangerous,
            'bankAccountLicense.imgUrl': this.licenseList.account,
            'ticketPost.imgUrl': this.licenseList.billing
          }).then(res => {
            // console.log(res)
            if (res.data.code === 0) {
              this.$router.push({ path: '/manage/companylist' })
            }
          })
        }
      }
    },
    handleCancelClick () { // 取消
      this.$router.push({ path: '/manage/companylist' })
    }
  },
  mounted () {
    this.initData()
    this.id = this.$route.query.item
    if (this.id) {
      this.getData(this.id)
      this.titlename = '修改'
      this.changeAddr = true
    }
  }
}
</script>

<style lang="stylus">
.addCompany
  height 100%
  .title
    padding-left 20px
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 23px left 103px #F7F9FB
    span
      color #212832
      margin-left 20px
  .company_container
    width calc(100% - 40px)
    background #fff
    height calc(100% - 50px)
    overflow auto
    margin 0 auto
    .company_title
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../assets/images/03/add_icon.png') no-repeat center left 15px
      border-bottom 1px solid #CFD5DC
    .companymain
      padding-top 20px
      overflow hidden
      padding-bottom 10px
      color #212832
      .company_list
        width 100%
        height 50px
        position relative
        label
          display inline-block
          width 168px
          text-align right
          color #5E656F
          margin-right 10px
          span
            color #FF344A
            margin-right 5px
        .el-input
          display inline-block
          color #212832
          width 220px
      .company_button
        width 100%
        height 50px
        position relative
        margin-left 178px
        margin-top 40px
        .el-button
          margin-right 40px
          padding 6px 24px
          font-size 12px
          &:nth-child(1)
            background #1b88ee
            color #fff
            border 1px solid #1B88EE
          &:nth-child(2)
            background #fff
            color #1B88EE
            border 1px solid #CFD5DC
      .licese
        max-width 1000px
        overflow hidden
        .licese_list
          width 400px
          margin-bottom 20px
          float left
          label
            float left
            width 168px
            text-align right
            color #5E656F
            margin-right 10px
            line-height 20px
            height 110px
            span
              color #FF344A
              margin-right 5px
          .imgItem
            width 174px
            height 114px
            float left
            position relative
            background #F7F9FB
            border 1px solid #CFD5DC
            border-radius 3px
            .imgUrl
              width 174px
              height 114px
              img
                width 100%
                height 100%
            .imgstyle
              position absolute
              top 0
              left 0
              width 174px
              height 114px
              .wating
                width 174px
                text-align center
                height 84px
                display table-cell
                vertical-align bottom
                background url('../../../assets/images/05/upload_n.png') no-repeat center bottom 20px
                color #CFD5DC
              .reupdate
                width 174px
                height 28px
                background rgba(0, 0, 0, 0.4)
                color #CFD5DC
                position absolute
                bottom 0
                left 0
                text-align center
                line-height 28px
            .updateBtn
              position absolute
              top 0px
              left 0px
              cursor pointer
              opacity 0
              right 0px
              bottom 0px
              overflow hidden
              width 174px
              &:hover>.wating
                background url('../../../assets/images/05/upload_h.png') no-repeat center bottom 20px
      .addressStyle
        .el-input
          display inline-block
          color #212832
          width 308px
        .areaaddress
          position absolute
          left 178px
          top 2px
      .address
        margin-left 178px
        .el-input
          width 308px
</style>
